import { Link } from '@tanstack/react-router'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '#/components/ui/breadcrumb'
import line from '#/assets/line.svg'
import defaultHeroImage from '#/assets/courses/course-hero.webp'
import { FaMosque } from 'react-icons/fa6'
import { cn } from '#/lib/utils'
import { ScrollReveal, RevealItem } from '#/components/common/ScrollReveal'
import { TextAnimate } from '#/components/common/TextAnimate'

type CustomHeroSectionProps = {
  gradientBackground?: string
  className?: string
  title: string
  breadcrumbLabel: string
  backgroundImage?: string
}

const CustomHeroSection = ({
  gradientBackground = 'primary-gradient',
  className,
  title,
  breadcrumbLabel,
  backgroundImage = defaultHeroImage,
}: CustomHeroSectionProps) => {
  return (
    <section
      className={cn('relative z-1 bg-cover bg-center', className)}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div
        className={cn(
          'absolute left-0 top-0 -z-1 h-full w-full',
          gradientBackground,
        )}
      />
      <div className="container mx-auto flex flex-col items-center gap-5 py-30 pt-40">
        <ScrollReveal className="flex flex-col items-center gap-5 w-full text-center">
          <RevealItem>
            <h1 className="text-6xl font-bold text-white max-md:text-5xl max-sm:text-4xl">
              <TextAnimate by="word" animation="fadeIn" duration={0.8}>
                {title}
              </TextAnimate>
            </h1>
          </RevealItem>

          <RevealItem>
            <img src={line} alt="Course line" />
          </RevealItem>

          <RevealItem>
            <Breadcrumb>
              <BreadcrumbList className="font-semibold text-white">
                <BreadcrumbItem>
                  <BreadcrumbLink
                    asChild
                    className="text-white hover:text-primary-300"
                  >
                    <Link to="/" className="flex items-center gap-2">
                      <FaMosque />
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-[color:var(--primary-500)]" />
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-[color:var(--primary-500)]">
                    {breadcrumbLabel}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </RevealItem>
        </ScrollReveal>
      </div>
    </section>
  )
}

export default CustomHeroSection
